module.exports = __webpack_public_path__ + "static/media/blue.ec0ae724.jpg";